import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AnimateHeight from 'react-animate-height'
import cn from 'classnames'
import { withState, withHandlers, compose } from 'recompose'

// Only collapses to initial height
const Collapse = (props) => {
  const { children, min, max, collapse, theme, duration, onAnimationStart, onAnimationEnd } = props
  const heightValue = (collapse) ? min : max
  const contentClassName = cn({}, theme)

  return (
    <AnimateHeight
      style={{width: "100%"}}
      contentClassName={contentClassName}
      duration={duration}
      onAnimationStart={onAnimationStart}
      onAnimationEnd={onAnimationEnd}
      height={ heightValue }>
      { children }
    </AnimateHeight>
  )
}

Collapse.propTypes = {
  collapse: PropTypes.bool.isRequired,
  min: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  max: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
}

Collapse.defaultProps = {
  collapse: false,
  min: 0,
  max: 'auto',
  duration: 500,
  onAnimationStart: () => {},
  onAnimationEnd: () => {}
}

const withCollapse = compose(
  withState('collapse', 'toggleCollapse', false),
  withHandlers({
    toggleCollapse: ({ toggleCollapse }) => () => toggleCollapse(t => !t)
  })
)

const withCollapseToggleOn = compose(
  withState('collapse', 'toggleCollapse', true),
  withHandlers({
    toggleCollapse: ({ toggleCollapse }) => () => toggleCollapse(t => !t)
  })
)

export {
  withCollapse,
  withCollapseToggleOn
}
export default Collapse
